import React from "react";

function normalizeRideStatus(status) {
  return String(status ?? "")
    .trim()
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
}

export function rideStatusVariant(status) {
  const value = normalizeRideStatus(status);
  if (!value) return "unknown";
  if (value.includes("cancel")) return "cancelled";
  if (value.includes("pending")) return "pending";
  if (value.includes("progress")) return "in-progress";
  if (value.includes("confirm")) return "confirmed";
  if (value.includes("accept")) return "accepted";
  if (value === "paid") return "paid";
  if (value.includes("end")) return "ended";
  return "unknown";
}

function RideStatusBadge({ status }) {
  const label = String(status ?? "").trim() || "—";
  const variant = rideStatusVariant(status);

  return (
    <span className={`ride-status-badge ride-status-badge--${variant}`}>
      {label}
    </span>
  );
}

export default RideStatusBadge;
